import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useTranslation } from "react-i18next";
import { useProjectShellStore } from "@/stores/projectShellStore";

type DeleteProjectDialogProps = {
  activeProjectId?: string;
  onDeleted?: () => void;
};

export function DeleteProjectDialog({
  activeProjectId,
  onDeleted,
}: DeleteProjectDialogProps) {
  const { t } = useTranslation();
  const closeDeleteDialog = useProjectShellStore((state) => state.closeDeleteDialog);
  const deleteDialog = useProjectShellStore((state) => state.deleteDialog);
  const deleteProject = useProjectShellStore((state) => state.deleteProject);

  if (!deleteDialog.target) {
    return null;
  }

  async function handleDelete() {
    const result = await deleteProject();
    if (activeProjectId && result.deletedProjectId === activeProjectId) {
      onDeleted?.();
    }
  }

  return (
    <AlertDialog
      onOpenChange={(open) => {
        if (!open) {
          closeDeleteDialog()
        }
      }}
      open={deleteDialog.open}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("projects.dialogs.deleteTitle", {
              name: deleteDialog.target.projectTitle,
            })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(deleteDialog.target.warningText)} {t("projects.dialogs.deleteBody")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={closeDeleteDialog}>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            disabled={!deleteDialog.target.confirmEnabled || deleteDialog.submitting}
            onClick={handleDelete}
          >
            {t("projects.dialogs.deleteConfirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
